<template>
  <div class="login-body">
    <form @submit.prevent="handleSubmit(cadastrar)">
      <div class="card-novo-usuario">
        <div class="card shadow-8 p-fluid grid formgrid p-ac-center" style="height: 400px">
          <h1>Validação de E-mail</h1>
          <div class="col-12">
            <Message severity="error" v-if="mensagemErro && tokenInvalido" :closable="false">{{ mensagemErro }}</Message>
            <Message severity="error" v-else-if="tokenInvalido" :closable="false">Token de Confirmação Inválido</Message>
            <Message severity="success" :closable="false" v-if="tokenValido">E-mail validado com sucesso</Message>
          </div>
          <div class="field col-4"></div>
          <div class="field col-12 md:col-4">
            <router-link :to="{ name: 'login' }">
              <Button label="Login" icon="pi pi-arrow-circle-left" iconPos="left" class="p-button-secondary mr-4"></Button>
            </router-link>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { logoutMixin } from "@/mixins";
import { validacaoFormulario } from "@/validacaoFormulario";
import AuthService from "../service/AuthService";

export default {
  mixins: [logoutMixin, validacaoFormulario],

  data() {
    return {
      messages: [],
      mensagemErro: null,
      tokenValido: false,
      tokenInvalido: false,
      authService: null,
    };
  },

  created() {
    this.authService = new AuthService();
  },
  mounted() {
    this.authService.confirmarEmail(this.$route.params.token)
                    .then( () => this.tokenValido = true )
                    .catch( err => {
                        this.tokenInvalido = true;
                        console.log(err.response.data.message);
                        this.mensagemErro = err.response.data.message;
                    });
  },

  methods: {

    addMessageError(errors) {
      for (let i = 0; i < errors.length; i++) {
        this.messages.push({
          severity: "error",
          content: `${errors[i].message}`,
        });
      }
    },
  },
};
</script>
